import styled from 'styled-components';
import { RADIUS } from '~/common/constants/border-radius';

import { SPACING } from '~/common/constants/spacing';

export const PrivateLayoutContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.neutral[950]};
  display: flex;
  flex-direction: row;
  /* Trava o scroll externo (body/#__next): apenas o BodyContainer rola.
     Sem isso, sobras de sub-pixel vazam para o scroll do documento e
     aparece um "container fantasma" ao forçar o scroll abaixo da tabela. */
  overflow: hidden;

  @media (max-width: 750px) {
    flex-direction: column;
    overflow-y: hidden;
  }
`;

export const StyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100vh - 65px);
  /* Contém o BodyContainer; o overflow do conteúdo fica no scroll interno
     (BodyContainer), não vaza para o body. */
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: ${SPACING._20};
  overflow-x: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.neutral[950]};

  @media (max-width: 750px) {
    padding-top: ${SPACING._12} !important;
    height: calc(100vh - 80px);
    padding: ${SPACING._16};
    overflow-x: hidden;
  }
`;

export const StyContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

export const StyContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
